import React, { Component } from 'react'
import {Link} from 'react-router-dom'
class EventBoxs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 1,
                    srcimg: 'images/services/certified.png',
                    title: 'Certified Contractors',
                    description: 'We are a class 1 contractor with a proven track record of delivering quality projects on time and within budget.',
                    url: '/about-v1'
                },
                {
                    id: 2,
                    srcimg: 'images/services/reputable.png',
                    title: 'Reputable Construction Company',
                    description: 'We provide a full range of construction services to our clients, from design and planning to construction and completion.',
                    url: '/about-v1'
                },
                {
                    id: 3,
                    srcimg: 'images/services/customer.png',
                    title: 'Exceptional Customer Service',
                    description: 'Our team of professionals are dedicated to providing the highest level of customer service and satisfaction.',
                    url: '/abblogout-v1'
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-md-4" key={data.id}>
                            <div className="imagebox-item">
                                <div className="imagebox style1">
                                    <div className="imagebox-image">
                                        <img src={data.srcimg} alt="financial" />
                                    </div>
                                    {/* <!-- /.imagebox-image --> */}
                                    
                                    <div className="imagebox-title">
                                        <h3><Link to={data.url} onClick={() => {window.location.href="/blog"}} title="">{data.title}</Link></h3>
                                    </div>
                                    {/* <!-- /.iamgebox-title --> */}
                                    <div className="imagebox-content">
                                        <div className="imagebox-desc">{data.description}</div>
                                        <div className="imagebox-button">
                                            <Link to={data.url} onClick={() => {window.location.href="/blog"}} title="">read more</Link>
                                        </div>
                                    </div>
                                    {/* <!-- /.imagebox-content --> */}
                                </div>
                                {/* <!-- /.imagebox --> */}
                            </div>
                            {/* <!-- /.imagebox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default EventBoxs;